import {
  CommandFeedback,
  type CommandFeedbackState,
} from "components/CommandFeedback";
import { commandWording } from "../command-wording";

import { describeReadFailure } from "./describe-read-failure";
import type { GovernanceCommandState } from "./use-governance-command";

// The governance counterpart of AdminCommandFeedback: the words follow the
// command type the state carries, through commandWording().
export function GovernanceCommandFeedback({
  state,
  onReset,
  testId,
}: {
  state: GovernanceCommandState;
  onReset: () => void;
  testId?: string;
}) {
  if (state.status === "idle") return null;

  const feedbackState: CommandFeedbackState =
    state.status === "submitting" || state.status === "watching"
      ? { status: "pending" }
      : state.status === "failed"
        ? { status: "failed", error: describeReadFailure(state.error) }
        : state;
  // A failed state shows its error, so its words are never rendered.
  const wording =
    state.status === "failed"
      ? { pending: "", success: "" }
      : commandWording(state.type);

  return (
    <CommandFeedback
      state={feedbackState}
      onReset={onReset}
      pendingMessage={wording.pending}
      successMessage={wording.success}
      testId={testId}
    />
  );
}
